import React from "react";
import { History, Layers, Scissors, CloudSun, Hourglass } from "lucide-react";
import { cn } from "../../lib/utils";

const TONE = {
  info: "text-info border-info/30 bg-info/10",
  warning: "text-warning border-warning/30 bg-warning/10",
  success: "text-success border-success/30 bg-success/10",
  neutral: "text-muted border-border bg-surface-2",
};

export function Chip({ tone = "neutral", icon: Icon, children, testid, title }) {
  return (
    <span data-testid={testid} title={title}
          className={cn("inline-flex items-center gap-1 px-1.5 h-[18px] rounded-sm border text-[9.5px] font-semibold uppercase tracking-wider whitespace-nowrap", TONE[tone])}>
      {Icon && <Icon size={9} />}{children}
    </span>
  );
}

// Rule-effect chips: legacy history, capped outliers, weather reclassification, Z-Intermittent.
export default function RuleChips({ row, testid }) {
  const chips = [];
  if (row.legacy?.length) chips.push(<Chip key="l" tone="info" icon={History} testid={`${testid}-legacy`}
    title={`Joined history from ${row.legacy.join(", ")}`}>Includes legacy part history</Chip>);
  if (row.capped_days > 0) chips.push(<Chip key="c" tone="warning" icon={Scissors} testid={`${testid}-capped`}
    title={`${row.capped_units} units above the cap removed from classification only`}>{row.capped_days} outlier day{row.capped_days === 1 ? "" : "s"} capped</Chip>);
  if (row.weather_reclassified) chips.push(<Chip key="w" tone="success" icon={CloudSun} testid={`${testid}-weather`}
    title={`R² ${row.weather_r2} on Cooling Degree Days`}>Weather-predictable ({row.xyz_original}→{row.xyz_final})</Chip>);
  if (row.intermittent) chips.push(<Chip key="z" tone="neutral" icon={Hourglass} testid={`${testid}-intermittent`}
    title={`${row.annual_units_raw} units in the trailing 12 months`}>Z-Intermittent</Chip>);
  if (row.matched_legacy) chips.push(<Chip key="m" tone="info" icon={Layers} testid={`${testid}-matched`}>Matched legacy {row.matched_legacy}</Chip>);
  if (!chips.length) return null;
  return <div className="flex flex-wrap gap-1 mt-1" data-testid={testid}>{chips}</div>;
}
